import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useQuery } from '@apollo/react-hooks';
import { MdApps, MdChevronLeft } from 'react-icons/md';
import Badge from '@material-ui/core/Badge';
import { toast } from 'react-toastify';

import { NavbarDiv, NavbarLogo, BurguerMenu, IconImg } from './styles';
import MainMenuItem from '../MainMenuItem/';
import { FlexContainer } from '../Dashboard/styles';

import Logo from '../../assets/images/logo-parquearauco.png';
import routers from '../../routes/routes.json';

import { GET_CAMERAS, GET_MALL_ACCESS } from '../../services/graphql/queries';
import {
  setCamerasCount,
  setConfigCount,
  setRead
} from '../../store/actions/NotificationActions';

export default function Navbar() {
  const [item, setItem] = useState('/');
  const [isOpen, setIsOpen] = useState(false);
  const [totalNotification, setTotalNotification] = useState(0);
  const dispatch = useDispatch();

  const read = useSelector(state => state.notification.read);

  const camerasNotification = useSelector(
    state => state.notification.camerasCount
  );

  const configNotification = useSelector(
    state => state.notification.configCount
  );

  const { data: cameras } = useQuery(GET_CAMERAS);
  const { data: config } = useQuery(GET_MALL_ACCESS);

  useEffect(() => {
    dispatch(setRead(false));
  }, [dispatch]);

  useEffect(() => {
    if (cameras) {
      if (cameras.getCameras) {
        let count = 0;

        count = cameras.getCameras.reduce((acc, camera) => {
          if (camera.mall_id === '1') {
            return acc + 1;
          } else return acc;
        }, 0);

        dispatch(setCamerasCount(count));
      }
    }
    if (config) {
      if (config.getMallAccess) {
        let count = 0;

        count = config.getMallAccess.reduce((acc, cfg) => {
          if (cfg.mall_id === '1') {
            return acc + 1;
          } else return acc;
        }, -1);

        dispatch(setConfigCount(count));
      }
    }
  }, [cameras, config, dispatch]);

  useEffect(() => {
    if (camerasNotification && configNotification) {
      setTotalNotification(camerasNotification + configNotification);
    }
  }, [camerasNotification, configNotification, dispatch]);

  useEffect(() => {
    if (!read && totalNotification > 0 && totalNotification < 2) {
      toast.warn('Tienes una configuración pendiente.', {
        autoClose: 6000
      });
      dispatch(setRead(true));
    } else if (!read && totalNotification > 1) {
      toast.warn(`Tienes ${totalNotification} configuraciones pendientes.`, {
        autoClose: 6000
      });
      dispatch(setRead(true));
    }
  }, [read, totalNotification, dispatch]);

  const menuItems = routers.map(data => {
    return (
      <MainMenuItem
        key={data.link_route}
        data={data}
        onClick={link => onClickItem(link)}
        route={item}
      />
    );
  });

  function onClickItem(route) {
    setItem(route);
  }

  function onClickNabvar() {
    setIsOpen(!isOpen);
  }

  return (
    <div>
      <FlexContainer>
        <NavbarDiv isOpen={isOpen}>
          <NavbarLogo isOpen={isOpen}>
            {isOpen ? <IconImg src={Logo} /> : null}
            <BurguerMenu>
              {isOpen ? (
                <MdChevronLeft
                  color={'#ffffff'}
                  size={25}
                  onClick={onClickNabvar}
                />
              ) : (
                <Badge
                  badgeContent={totalNotification}
                  color="secondary"
                  invisible={totalNotification <= 0}
                >
                  <MdApps color={'#ffffff'} size={25} onClick={onClickNabvar} />
                </Badge>
              )}
            </BurguerMenu>
          </NavbarLogo>
          {isOpen && menuItems}
        </NavbarDiv>
      </FlexContainer>
    </div>
  );
}
